import PropTypes from "prop-types";
import filterChildren from "../../../utils/Children/filterChildren";
import "./Table.scss";

const TableTitle = ({
  id,
  className,
  secondary,
  onSecondaryTitleClick,
  style,
  secondaryStyle,
  children,
}) => {
  const newChildren = filterChildren(children);

  return (
    <caption
      id={id}
      className="bg-white text-brand-blue border-b border-b-light-border-blue rounded-t p-4 text-left text-xl relative"
      style={style}
    >
      <h3 className="absolute text-base leading-6 font-normal top-1/2 transform -translate-y-1/2 app-components-table-title__primary-title">
        {newChildren}
      </h3>
      {
        <span className="float-right text-sm leading-5 relative app-components-table-title__secondary">
          {onSecondaryTitleClick ? (
            <a
              type="link"
              className="text-action-blue text-left font-semibold cursor-pointer whitespace-no-wrap unset"
              onClick={onSecondaryTitleClick}
              style={secondaryStyle}
              role="link"
              tabIndex={0}
            >
              {secondary}
            </a>
          ) : (
            <span style={secondaryStyle}>{secondary}</span>
          )}
        </span>
      }
    </caption>
  );
};

TableTitle.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Secondary text or node */
  secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** On Secondary text click function if clickable */
  onSecondaryTitleClick: PropTypes.func,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Override the inline-styles of the secondary title element || Not Recommended */
  secondaryStyle: PropTypes.object,
  /** children props for content inside */
  children: PropTypes.node,
};

TableTitle.defaultProps = {
  id: "",
  className: "",
  children: null,
  onSecondaryTitleClick: null,
  style: {},
  secondaryStyle: {},
  secondary: "",
};

export default TableTitle;
